// extracted by mini-css-extract-plugin
export default {"nav__link":"NavItem_nav__link__yMuNi","nav__link__dark":"NavItem_nav__link__dark__RD8vC","nav__num":"NavItem_nav__num__U0Ew0","nav__num__dark":"NavItem_nav__num__dark__jGm5Y"};